import { Link } from "react-router-dom";
import "../styles/CategoryCard.css";

export default function CategoryCard({ category }) {
  return (
    <Link to={`/category/${category.cid}`} state={{ categoryName: category.name }} className="category-card">

      <img
        src={category.image}
        alt={category.name}
        className="category-img"
      />

      <h3>{category.name}</h3>
    </Link>
  );
}